module.exports = "<a class=\"item pending-upload-left double-line item-requirement\">\r\n  <div class=\"pending-upload-thumb-container\" ng-if=\"::uploadItem.isImage\">\r\n    <img ng-src=\"{{::uploadItem.imageData}}\">\r\n  </div>\r\n  <div class=\"pending-upload-thumb-container\" ng-if=\"::!uploadItem.isImage\">\r\n    <!--TODO(UI): display appropriate file type icon-->\r\n    {{::uploadItem.fileIcon}}\r\n  </div>\r\n  <span>{{::uploadItem.model.filename}}</span><br>\r\n  <span class=\"pending-status\">{{uploadItem.progress | number:0}}</span>\r\n</a>";


//////////////////
// WEBPACK FOOTER
// ./src/js/core-utilities/upload-service/pending-upload/list-item.html
// module id = 2808
// module chunks = 0